<div class="basic-data-step">
  <div class="content-container">
    <!-- Dane z umowy (tylko do odczytu) -->

    <div class="content-card">
      <div class="section-header">
        <h3>{{ 'Annex.BasicData' | translate }}</h3>

        <div class="status-indicator">
          @if (loadingState.isLoading) {
            <mat-spinner diameter="24" color="primary"></mat-spinner>
          }
          @if (loadingState.showSuccess) {
            <mat-icon class="success-icon" [@successAnimation]> check_circle </mat-icon>
          }
        </div>
      </div>
      <form [formGroup]="readOnlyDataForm">
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'FullName' | translate }}</mat-label>
              <input matInput formControlName="fullName" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmploymentType' | translate }}</mat-label>
              <input matInput formControlName="employmentType" />
            </mat-form-field>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-lg-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmploymentDateFrom' | translate }}</mat-label>
              <input matInput formControlName="employmentDateFrom" />
            </mat-form-field>
          </div>
          <div class="col-12 col-lg-6">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'EmploymentDateTo' | translate }}</mat-label>
              <input matInput formControlName="employmentDateTo" />
            </mat-form-field>
          </div>
        </div>
      </form>

      @if (basicDataForm) {
        <form [formGroup]="basicDataForm">
          <div class="row">
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Annex.ConclusionDate' | translate }}</mat-label>
                <input
                  matInput
                  id="basic-data-step-annex-conclusion-date-input"
                  [matDatepicker]="pickAnnexConclusionDate"
                  formControlName="annexConclusionDate"
                  [matDatepickerFilter]="annexConclusionDateFilter"
                />
                <mat-datepicker-toggle matSuffix [for]="pickAnnexConclusionDate"></mat-datepicker-toggle>
                <mat-datepicker #pickAnnexConclusionDate></mat-datepicker>
                @if (annexConclusionDate.invalid && annexConclusionDate.touched) {
                  <mat-error>
                    {{ 'InvalidField' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="col-12 col-lg-6">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'Annex.DateFrom' | translate }}</mat-label>
                <input
                  id="basic-data-step-annex-date-from-input"
                  matInput
                  [matDatepicker]="pickAnnexDateFrom"
                  formControlName="annexDateFrom"
                  [matDatepickerFilter]="annexDateFromFilter"
                />
                <mat-datepicker-toggle matSuffix [for]="pickAnnexDateFrom"></mat-datepicker-toggle>
                <mat-datepicker #pickAnnexDateFrom></mat-datepicker>
                @if (annexDateFrom.invalid && annexDateFrom.touched) {
                  <mat-error>
                    {{ 'InvalidField' | translate }}
                  </mat-error>
                }
              </mat-form-field>
            </div>
          </div>
          @if (!agreement.EmploymentDateTo) {
          <div class="row">
            <div class="col-12">
              <mat-checkbox id="basic-data-step-annex-is-indefinite-checkbox" formControlName="isIndefinite">
                {{ 'Annex.IsIndefinite' | translate }}
              </mat-checkbox>
            </div>
          </div>
          }

          @if (!isIndefinite.value) {
            <div class="row">
              <div class="col-12 col-lg-6">
                <mat-form-field appearance="outline">
                  <mat-label>{{ 'Annex.DateTo' | translate }}</mat-label>
                  <input
                    id="basic-data-step-annex-date-to-input"
                    matInput
                    [matDatepicker]="pickAnnexDateTo"
                    formControlName="annexDateTo"
                    [matDatepickerFilter]="annexDateToFilter"
                  />
                  <mat-datepicker-toggle matSuffix [for]="pickAnnexDateTo"></mat-datepicker-toggle>
                  <mat-datepicker #pickAnnexDateTo></mat-datepicker>
                  @if (annexDateTo.invalid && annexDateTo.touched) {
                    <mat-error>
                      @if (annexDateTo.hasError('required')) {
                        {{ 'InvalidField' | translate }}
                      }
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          }
        </form>
      }
    </div>
  </div>
</div>
